import { CountryBannerResponse } from './types'

export const fetchCountryInfo = async (
  countryCode: string,
  pagePath = ''
): Promise<CountryBannerResponse | null> => {
  try {
    if (!pagePath) {
      return null
    }
    const url = `/${pagePath}.countryBanner.${countryCode?.toLowerCase()}.json`
    const response = await fetch(url)
    if (!response.ok) {
      return null
    }
    const data = await response.json()

    if (!data || !data.isoCode) {
      return null
    }
    return data
  } catch {
    return null
  }
}
